import _Model from "./_Model";
import Device from "./Device";
import { busExpansionType, edgeClusterHead, edgeClusterTermination, powerSupplyFieldBus } from "../constants";

export default class ModuleBlock extends _Model {
  constructor(json) {
    super(json);
    this.modules = ModuleBlock.getMappedOrDefault(json, 'modules', [], data => (data || []).map(d => new Device(d || {})));
  }

  length() {
    return this.modules.length;
  }

  sortedModules() {
    return this.modules.sort((a, b) => a.slot - b.slot);
  }

  isCountableModule(device) {
    let result = true;

    if (busExpansionType.receiver === device.busExpansionType
        || busExpansionType.transmitter === device.busExpansionType) {
        return false;
    }

    // EDGE non countable modules
    if (edgeClusterTermination === device.productType || powerSupplyFieldBus === device.productType || edgeClusterHead === device.productType) {
        result = false;
    }

    return result;
  }


  countableModules() {
    return this.sortedModules()
      .filter(m => this.isCountableModule(m));
  }

  hasWidth() {
    // If the first module of the block has the both expansion type, then we are in a TM7 block and the width is not relevant.
    return !(this.length() > 0 && busExpansionType.both === this.modules[0].busExpansionType);
  }

  maxModuleHeight() {
    let maxModuleHeight = 0;
    for (const mod of this.modules) {
      const moduleHeight = mod?.height || 0;
      if (moduleHeight > maxModuleHeight) {
        maxModuleHeight = moduleHeight;
      }
    }
    return maxModuleHeight;
  }

  width() {
    if (!this.hasWidth()) {
      return '-';
    }
    return this.modules.map(m => m.width)
      .reduce((a, b) => parseFloat((a + b).toFixed(2)), 0.0)
      .toString();
  }

  containsModule(module) {
    return this.modules.find(m => m.slot === module.slot && m.id === module.id) !== undefined;
  }

  /**
   * Check if the given module is the first module
   * @param {*} module
   */
  isFirstModule(module) {
    const firstSlot = this.modules.map(d => d.slot).reduce((a, b) => a < b ? a : b, 99999);
    const firstModule = this.modules.find(m => m.slot === firstSlot);
    if (!firstModule) {
      return false;
    }
    return firstModule.slot === module.slot && firstModule.id === module.id;
  }

  /**
   * Check if the given module is the last module
   * @param {*} module
   */
  isLastModule(module) {
    const lastSlot = this.modules.map(d => d.slot).reduce((a, b) => a > b ? a : b, 0);
    const lastModule = this.modules.find(m => m.slot === lastSlot);
    if (!lastModule) {
      return false;
    }
    return lastModule.slot === module.slot && lastModule.id === module.id;
  }
}
